import { createAction } from 'redux-actions';
import { PapiDeviation } from '@wix/da-papi-types';

export const updateDeviationTitle = createAction(
  'STUDIO.UPDATE_DEVIATION_TITLE',
  (deviation: PapiDeviation, title: string) => ({ deviation, title })
);
